import { render } from "./FileExcel.vue.js?vue&type=template&id=748ce28a!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FileExcel.vue?vue&type=template&id=748ce28a"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__